import PaymentMethodFields from "@/pages/profile/PaymentMethodFields";
import {stripePromise} from "@/stripe";
import {Elements} from "@stripe/react-stripe-js";
import type {FC} from "react";
import {useTranslation} from "react-i18next";

const AddPaymentMethodForm: FC<{currency: string; onClose: () => void}> = ({currency, onClose}) => {
  const {i18n} = useTranslation("common");

  return (
    <Elements
      stripe={stripePromise}
      options={{
        mode: "setup",
        currency: currency.toLowerCase(),
        locale: i18n.language === "ger" ? "de" : "en",
      }}>
      <PaymentMethodFields onClose={onClose} />
    </Elements>
  );
};

export default AddPaymentMethodForm;
